import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { LinksProvider, VuiProvider } from '@veracity/vui'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { ReactQueryProvider } from '@/contexts'

import { App } from './App'
import './styles/main.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <VuiProvider>
      <LinksProvider>
        <ReactQueryProvider>
          <App />
          <ReactQueryDevtools />
        </ReactQueryProvider>
      </LinksProvider>
    </VuiProvider>
  </StrictMode>
)
